import { NextPage } from 'next'
import Head from 'next/head'
import React, { useContext } from 'react'

import { Breadcrumbs } from '@Components/Breadcrumbs'
import { ContactContent } from '@Components/Contact/Content'
import { Link } from '@Components/Link'
import { NavigationEvent } from '@Events/Navigation'
import { PageView } from '@Events/PageView'
import { PageViewGA } from '@Globals/Google/Analytics'
import { DataLayer } from '@Globals/Google/DataLayer'
import { SplitTestsContext } from '@Globals/SplitTests/Context'
import { Group } from '@Globals/SplitTests/Group'
import { storeURL } from '@Globals/Store'
import { useTranslation } from '@Globals/Translations'
import { TwoColumn } from '@Layouts/TwoColumn'

const ContactPage: NextPage = () => {
  const { t } = useTranslation()
  const { activateSplitTest } = useContext(SplitTestsContext)

  activateSplitTest('fv2_info_contact_v1', Group.B)

  return (
    <>
      <Head>
        <title>{t('contact:CONTACT_PAGE_TITLE')}</title>
        <meta
          key="og:title"
          content={t('contact:CONTACT_PAGE_TITLE')}
          property="og:title"
        />
        <meta
          key="og:url"
          content={storeURL('info/contact')}
          property="og:url"
        />
        <meta
          key="robots"
          content="INDEX,FOLLOW"
          name="robots"
        />
      </Head>
      <DataLayer input={{ contentIds: '', pageType: 'contact' }} />
      <PageViewGA />
      <PageView
        eventProps={{
          attributes: {},
          pageName: 'contact',
        }}
      />
      <TwoColumn>
        <Breadcrumbs>
          <Link
            event={new NavigationEvent({
              attributes: {
                dest_page_type: 'category',
                dest_page_type_id: '',
                source_id: 'bread_crumb',
              },
              eventName: 'nav_link_click',
            })}
            href={storeURL('info')}
          >
            {t('contact:CUSTOMER_SUPPORT')}
          </Link>
          <Link
            event={new NavigationEvent({
              attributes: {
                dest_page_type: 'category',
                dest_page_type_id: '',
                source_id: 'bread_crumb',
              },
              eventName: 'nav_link_click',
            })}
            href={storeURL('info/contact')}
          >
            {t('contact:CONTACT_PAGE_TITLE')}
          </Link>
        </Breadcrumbs>
        <ContactContent />
      </TwoColumn>
    </>
  )
}

ContactPage.getInitialProps = async () => ({
  namespacesRequired: ['common', 'contact', 'footer', 'header', 'sidebar', 'validation'],
  page: {
    id: '',
    type: 'contact',
  },
})

export default ContactPage
